import { render, staticRenderFns } from "./ModalCertificateFile.vue?vue&type=template&id=36b934a8&"
import script from "./ModalCertificateFile.vue?vue&type=script&lang=js&"
export * from "./ModalCertificateFile.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertificateFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports